import { cn } from "@/lib/utils";
import { extractTokenValue } from "@/utils/helpers/tokenUtils";

export interface ULThemeLogoProps {
  /**
   * Optional image url of the logo.
   */
  imageUrl?: string;
  /**
   * Alt Text for the logo image
   */
  altText: string;
  /**
   * Optional Classes for custom overrides
   */
  className?: string;
}

const ULThemeLogo = ({
  imageUrl,
  altText,
  className,
}: ULThemeLogoProps) => {
  // Using extractTokenValue utility to extract the logo URL, Logo Visible flags from CSS variable
  const themedLogoSrcValue = extractTokenValue("--ul-theme-widget-logo-url");
  const isLogoHidden =
    extractTokenValue("--ul-theme-widget-logo-position") === "none";
  const themedStylesAvatar = "flex flex-wrap justify-widget-logo";
  const themedStylesAvatarImg = "h-(--height-widget-logo)";
  const logoSrc = themedLogoSrcValue || imageUrl;

  return (
    !isLogoHidden && (
      <div className={cn(themedStylesAvatar, className)}>
        <img
          src={logoSrc}
          alt={altText}
          className={cn(themedStylesAvatarImg, "w-auto object-contain")}
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
      </div>
    )
  );
};
export default ULThemeLogo;
